import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import { useAppBridge } from '@shopify/app-bridge-react';

import { Page,
         Card,
         TextField,
         Button,
         Box,
         InlineStack,
         Text,
         Select,
         Badge,
         IndexTable,
         Divider,
         BlockStack,
         Form,
         FormLayout,
         Checkbox,
         InlineError,
         Link,
         Banner,
         Thumbnail,
         SkeletonThumbnail,
         Icon,
         ButtonGroup,
         DescriptionList,
         DataTable,
         EmptyState,
         PageActions
       } from '@shopify/polaris';

import {
  BarcodeIcon,
  SearchIcon,
  DeleteIcon,
  AlertTriangleIcon,
  OrderFulfilledIcon,
  ResetIcon
} from '@shopify/polaris-icons';

import PageFooter from '../partials/PageFooter';
import LoadingSpinner from '../partials/LoadingSpinner';
import LineItem from "./LineItem";
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import CorrectScanDialog from "./CorrectScanDialog";
import IncorrectScanDialog from "./IncorrectScanDialog";
import RepeatScanDialog from "./RepeatScanDialog";

import { getIncompleteOrders } from '../../redux/actions/incompleteOrders';

import { readOrder,
         setCheckedList,
         setUnpickableList,
         clearOrder,
         createFulfillment } from '../../redux/actions/pickOrder';

const PickOrder = ({ 
  shopUrl, 
  payload, 
  pickOrder, 
  fulfillments, 
  fulfillmentLocations, 
  fulfillmentStatus, 
  searchOrder, 
  pushCheckedList, 
  resetOrder, 
  loadOrderStatuses, 
  updateStatus, 
  pushFulfillment, 
  checkedItems, 
  pushUnpickableList, 
  requiresRefresh,
  indexEndCursor,
  indexStartCursor,
  indexHasNextPage,
  indexHasPreviousPage,
  submitOrderIndex,
  incompleteOrders }) => {
  let { orderId } = useParams();

  const [locationsList, setLocationsList] = useState([]);
  const [location, setLocation] = useState('');

  const [searchSubmitted, setSearchSubmitted] = useState(false);

  const [orderScan, setOrderScan] = useState('');
  const [scanTerm, setScanTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  const [dialogQuantity, setDialogQuantity] = useState(0);
  const [dialogLineItemId, setDialogLineItemId] = useState();
  const [displayConfirmOrderUpdate, setDisplayConfirmOrderUpdate] = useState(false);

  const [scanFocused, setScanFocused] = useState('');
  const [hidePickedItems, setHidePickedItems] = useState(true);
  
  const [bannerTitle, setBannerTitle] = useState('Scan items to see results');
  const [bannerTone, setBannerTone] = useState('info');
  const [bannerComment, setBannerComment] = useState(null);
  const [bannerCount, setBannerCount] = useState(null);
  const [bannerItem, setBannerItem] = useState(null);

  const [showCouldNotPick, setShowCouldNotPick] = useState(false);

  const shopify = useAppBridge();

  useEffect(() => {
    if(orderId) {
      searchOrder(shopUrl, payload, orderId);
      setSearchSubmitted(true);
    } else {
      submitOrderIndex(shopUrl, payload, 'next', null, null);
    }
  }, []);

  useEffect(() => {
    setSelectedStatus(fulfillmentStatus);
  }, [fulfillmentStatus])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(scanTerm !== ''){
        let matchingFulfillment = fulfillments.find(fulfillment => { return (fulfillment['location']['id'] === location) });
        let matchingLine = matchingFulfillment['line_items'].find(lineItem => { return ((lineItem.variant.barcode === scanTerm) || (lineItem.variant.sku === scanTerm)); });

        if(!matchingLine) {
          incorrectDialog();
          setShowCouldNotPick(false);
        } else {
          setDialogQuantity(matchingLine.remainingQuantity);
          if(pickOrder.checkedItems.includes(matchingLine.id)) {
            repeatDialog(matchingLine);
            setShowCouldNotPick(false);
          } else {
            setDialogLineItemId(matchingLine.id);
            correctDialog(matchingLine);
            toggleChecked(matchingLine.id);
            setShowCouldNotPick(true);
          }
        }

        setScanTerm('');
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [scanTerm, 500]);

  useEffect(() => {
    if(pickOrder.status === 'success') {
      let tempLocations = [];
      fulfillmentLocations.forEach((location) => {
        tempLocations.push({ label: location.name, value: location.id })
      })

      setLocationsList(tempLocations);
    }
  }, [fulfillmentLocations]);

  const searchNext = () => {
    submitOrderIndex(shopUrl, payload, 'next', indexEndCursor, indexStartCursor);
  }

  const searchPrevious = () => {
    submitOrderIndex(shopUrl, payload, 'previous', indexEndCursor, indexStartCursor);
  }


  const updateOrder = (event) => {
    setOrderScan(event);
  }

  const updateScan = (event) => {
    setScanTerm(event);
  }

  const submitSearch = (searchId) => {
    let search = (searchId || orderScan);

    searchOrder(shopUrl, payload, search.replaceAll('#',''));
    setSearchSubmitted(true);

    setBannerTitle('Scan items to see results');
    setBannerTone('info');
    setBannerComment(null);
    setBannerCount(null);
    setBannerItem(null);
    setShowCouldNotPick(false);
  }

  const handleSelection = (selectionType, toggleType, selection, position) => {
    if(selectionType === 'page' && toggleType) { confirmAllList(); }
    if(selectionType === 'page' && !toggleType) { unconfirmAllList(); }

    if(selectionType === 'single') { toggleChecked(selection); }
  }

  const confirmAllList = () => {
    let locationFulfillment = fulfillments.find((fulfillment) => fulfillment.location.id === location);

    locationFulfillment.line_items.forEach((lineItem) => {
      if(!checkedItems.includes(lineItem.id)) {
        toggleChecked(lineItem.id);
      }
    });
  }

  const unconfirmAllList = () => {
    pushCheckedList([]);
  }

  const toggleChecked = (lineItemId) => {
    let newChecked = pickOrder.checkedItems;

    if(pickOrder.checkedItems.includes(lineItemId)) {
      newChecked.splice(pickOrder.checkedItems.indexOf(lineItemId), 1);
    } else {
      newChecked.push(lineItemId);
    }

    pushCheckedList(newChecked);
  }

  const switchUnpickable = (lineItemId) => {
    let newUnpickable = pickOrder.unpickableItems;

    if(pickOrder.unpickableItems.includes(lineItemId)) {
      newUnpickable.splice(pickOrder.unpickableItems.indexOf(lineItemId), 1);
    } else {
      newUnpickable.push(lineItemId);
    }

    pushUnpickableList(newUnpickable);
  }

  const focusScanArea = () => {
    let area = document.getElementById('scan-bar');
    area.focus();
  }

  const reset = () => {
    resetOrder();
    setOrderScan('');
    setLocation('');
    setSearchSubmitted(false);
  }

  const resetUnpickable = () => {
    pushUnpickableList([]);
    shopify.modal.hide('correct-modal');
    focusScanArea();
  }

  const switchFulfillmentStatus = (event) => {
    let status = pickOrder.fulfillmentStatuses.find(status => status.status_id === event.target.value);
    setSelectedStatus(status.status_id);
  }

  const handleLocationSelect = (event) => {
    setLocation(event);
    pushCheckedList([]);
  }

  const completeFulfillment = (fulfillment) => {
    pushFulfillment(shopUrl, payload, fulfillment);
    reset();
    submitOrderIndex(shopUrl, payload, 'next', null, null);
  }

  const correctDialog = (item) => {
    setBannerTitle('Correct Item');
    setBannerTone('success');
    setBannerComment('The scanned item is in this order. Please pick this quantity:')
    setBannerCount(item.remainingQuantity);
    setBannerItem(item);
  }

  const incorrectDialog = () => {
    setBannerTitle('Incorrect Item');
    setBannerTone('critical');
    setBannerComment('The scanned item is not in this order. Do not pick.')
    setBannerCount(null);
    setBannerItem(null);
  }

  const repeatDialog = (item) => {
    setBannerTitle('Repeat Item');
    setBannerTone('warning');
    setBannerComment('The scanned item is in this order, but may have already been picked. Please confirm this quantity:')
    setBannerCount(item.remainingQuantity);
    setBannerItem(null);
  }

  const pickButton = (order) => {
    if(order.fulfillable) {
      return <Button
        onClick={() => submitSearch(order.name)}
        disabled={pickOrder.status === 'requesting'}
      >
        Pick Order {order.name} 
      </Button>
    }

    return <></>
  }

  const fulfillableBadge = (order) => {
    if(order.fulfillable) {
      return <Badge tone="success">Fulfillable</Badge>
    } else {
      return <Badge tone="warning">Unfulfillable</Badge>
    }
  }

  const orderRow = (order, index) => {
    let shipmentInfo = '';
    if(order['node'].shippingAddress) {
      shipmentInfo = `Shipment to ${order['node'].shippingAddress.city} ${order['node'].shippingAddress.provinceCode}, ${order['node'].shippingAddress.countryCodeV2}`;
    }

    return [
      order['node'].name,
      fulfillableBadge(order['node']),
      shipmentInfo,
      pickButton(order['node'])
    ]
  }

  const fulfillmentComplete = (fulfillment) => {
    return(
      <>
        { (fulfillment['line_items'].length === pickOrder.checkedItems.length) && pickOrder.unpickableItems.length === 0 &&
          <Card>
            <BlockStack gap="200">
              <Text variant="headingXl" as="h4">Picking Complete</Text>
              <Text variant="headingLg" as="h5">Next Steps</Text>

              <Text>Update the order, print packing slips and print order details. <Link target="_blank" url={`https://admin.shopify.com/orders/${pickOrder.orderGid}`}>View Order</Link></Text>
              
              <Divider borderColor="border" />

              <InlineStack align="end">
                <ButtonGroup>
                  <Button icon={DeleteIcon} variant="secondary" onClick={() => reset()}>
                    Clear Order
                  </Button>

                  <Button icon={OrderFulfilledIcon} variant="primary" onClick={() => completeFulfillment(fulfillment)}>
                    Complete Fulfillment and Clear Order
                  </Button>
                </ButtonGroup>
              </InlineStack>

              
            </BlockStack>
          </Card>
        }
      </>
    )
  }

  const fulfillmentFailed = (fulfillment) => {
    return(
      <>
        { pickOrder.unpickableItems.length > 0 &&
          <Card>
            <BlockStack gap="200">
              <Text variant="headingXl" as="h4">Could Not Pick</Text>
              <Text variant="headingLg" as="h5">Next Steps</Text>
              
              <Text>Update the order's status if needed, and clear the order to pick and verify another order. <Link target="_blank" url={`https://admin.shopify.com/orders/${pickOrder.orderGid}`}>View Order</Link></Text>
              
              <Divider borderColor="border" />

              <InlineStack align="end">
                <ButtonGroup>
                  <Button icon={ResetIcon} variant="secondary" onClick={() => resetUnpickable()}>Reset "could not pick" status</Button>
                  <Button icon={DeleteIcon} variant="primary" onClick={() => reset()}>Clear Order</Button>
                </ButtonGroup>
              </InlineStack>

            </BlockStack>
          </Card>
        }
      </>
    )
  }

  if(!pickOrder.orderId || pickOrder.status !== 'success' || pickOrder.orderFulfillmentStatus === 'FULFILLED') {
    return(
      <Page 
        title="Pick and Verify Orders"
        backAction={{content: 'Back', url: 'https://' + window.location.hostname + window.location.search}}
      >
        <BlockStack gap="400">
          { requiresRefresh &&
            <RequiresRefreshBanner />
          }
          <Card>
            <Form onSubmit={() => submitSearch()}>
              <FormLayout>
                <TextField
                  id="storeId"
                  label="Order Number"
                  value={orderScan}
                  onChange={updateOrder}
                  autoComplete="off"
                  placeholder="Search Order Number"
                  disabled={pickOrder.status === 'requesting'}
                  loading={pickOrder.status === 'requesting'}
                  connectedRight={
                    <Button icon={SearchIcon} variant="primary" submit disabled={pickOrder.status === 'requesting'}>
                      Search
                    </Button>
                  }
                />
                { pickOrder.errors && <InlineError message={pickOrder.errors} fieldID="storeId" /> }
                { pickOrder.orderFulfillmentStatus === 'FULFILLED' && <InlineError message={`Order ${pickOrder.orderId} has already been fulfilled.`} fieldId="storeId" /> }
              </FormLayout>
            </Form>
          </Card>

          <Card>
            <BlockStack gap="200">
              <Text variant="headingXl" as="h4">Open Orders</Text>

              { incompleteOrders.status === 'success' && incompleteOrders.orders.length > 0 &&
                <DataTable
                  headings={[
                    'Order',
                    'Fulfillable',
                    'Address',
                    'Actions'
                  ]}
                  columnContentTypes={[
                    'text',
                    'text',
                    'text',
                    'text'
                  ]}
                  hasZebraStripingOnData
                  rows={incompleteOrders.orders.map((item, index) => orderRow(item, index))}
                  pagination={{
                    hasPrevious: indexHasPreviousPage,
                    hasNext: indexHasNextPage,
                    onNext: () => {searchNext()},
                    onPrevious: () => {searchPrevious()},
                  }}
                />
              }
              { incompleteOrders.status === 'success' && incompleteOrders.orders.length === 0 &&
                <EmptyState
                  heading="No Open Orders"
                  image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                >
                  <p>You're all caught up! When you have open orders, they'll appear in a list here.</p>
                </EmptyState>
              }
              { incompleteOrders.status !== 'success' &&
                <LoadingSpinner size="small" statusText=" Loading open orders..." />
              }
            </BlockStack>
          </Card>
        </BlockStack>

        <PageActions
          primaryAction={
            <Button
              onClick={() => submitOrderIndex(shopUrl, payload, 'next', null, null)}
            >
              Refresh Open Orders
            </Button>
          }
        />

        <PageFooter stripeBackground='#070808' helpLink="inventory-management/pick-and-verify-orders-with-shopify/" helpDescription="picking and verifying orders" />
      </Page>
    )
  }

  return(
    <Page 
      title="Pick and Verify Orders"
      backAction={{content: 'Back', url: 'https://' + window.location.hostname + window.location.search}}
      primaryAction={
        <Button icon={DeleteIcon} variant="secondary" onClick={() => reset()}>
          Clear Order
        </Button>
      }
      secondaryActions={
        <Checkbox
          label="Hide picked items"
          checked={hidePickedItems}
          onChange={() => setHidePickedItems(!hidePickedItems)}
        />
      }
    >
      { requiresRefresh &&
        <RequiresRefreshBanner />
      }
      <Card>
        <BlockStack gap="400">

          <DescriptionList
            items={[
              {
                term: 'Fulfillment Locations',
                description:
                  <>
                    { fulfillmentLocations.length > 0 &&
                      <Box>
                        <Select
                          options={locationsList}
                          onChange={handleLocationSelect}
                          value={location}
                          placeholder="Select location"
                        />
                      </Box>
                    }
                    { fulfillmentLocations.length === 0 && <Text>No fulfillment locations found.</Text> }
                  </>
                  
              },
              {
                term: 'Scan Barcode (SKU, UPC, EAN)',
                description:
                  <TextField
                    id="scan-bar"
                    value={scanTerm}
                    onChange={updateScan}
                    autoComplete="off"
                    disabled={!location}
                    placeholder={ scanFocused ? "Scan barcode" : "Click here to begin scanning" }
                    prefix={<Badge tone={ scanFocused ? 'success' : 'critical' }>{ scanFocused ? 'Ready' : 'Not ready' }</Badge>}
                    onFocus={() => setScanFocused(true)}
                    onBlur={() => setScanFocused(false)}
                    connectedLeft={
                      <Icon
                        source={BarcodeIcon}
                        tone="base"
                      />
                    }
                  />
              }
          ]} />

          { pickOrder.unpickableItems.length === 0 &&
            <Banner title={bannerTitle} tone={bannerTone} onDismiss={() => {}}>
              { bannerItem && <Card>
                { bannerItem?.variant?.product?.featuredMedia?.preview?.image?.url && <Thumbnail size="small" source={bannerItem?.variant?.product?.featuredMedia?.preview?.image?.url} alt={bannerItem?.variant?.product?.featuredMedia?.preview?.image?.altText}/> }
                { !bannerItem?.variant?.product?.featuredMedia?.preview?.image?.url && <SkeletonThumbnail size="small" /> }
                <Text>{bannerItem.variant.displayName}</Text>
                {bannerItem.variant.selectedOptions.map(option => 
                  <div key={option.name}>
                    <Badge 
                      tone="info"
                      key={option.name}
                    >
                      <Text>{option.value}</Text>
                    </Badge>
                     &nbsp;
                  </div>
                )}
              </Card>}
              { bannerComment && <Text alignment="center">{bannerComment}</Text> }
              { bannerCount && <Text variant="heading2xl" alignment="center">{bannerCount}</Text> }
              { showCouldNotPick && 
                <InlineStack align="end">
                  <ButtonGroup>
                    <Button icon={AlertTriangleIcon} onClick={ () => switchUnpickable(dialogLineItemId) }>Could not pick</Button> 
                  </ButtonGroup>
                </InlineStack>  
              }
            </Banner>
          }

        <Divider borderColor="border" />

          { location && fulfillments.length > 0 &&
            <>
              { fulfillments.map((fulfillment, index) =>
                <div key={`fulfillment-${index}`}>
                  { fulfillmentComplete(fulfillment) }
                  { fulfillmentFailed(fulfillment) }
                  { (fulfillment['location']['id'] === location) &&
                    <>
                      <IndexTable
                        resourceName={{ singular: 'product', plural: 'products' }}
                        itemCount={fulfillment['line_items'].length}
                        selectedItemsCount={checkedItems.length}
                        onSelectionChange={handleSelection}
                        headings={[
                          {title: ''},
                          {title: 'Product'},
                          {title: 'Barcode'},
                          {title: 'SKU'},
                          {title: 'Options'},
                          {title: 'Quantity', alignment: 'end'}
                        ]}
                      >
                        {fulfillment['line_items']?.map((lineItem, index) => (
                            <LineItem
                              key={`item-${index}`}
                              index={index}
                              lineItem={lineItem}
                              toggleChecked={toggleChecked}
                              setDialogLineItemId={setDialogLineItemId}
                              setDisplayConfirmOrderUpdate={setDisplayConfirmOrderUpdate}
                              hidePickedItems={hidePickedItems}
                            />
                          )
                        )}
                      </IndexTable>
                    </>
                  }
                </div>
              )}
            </>
          }

        </BlockStack>
      </Card>
      
      <PageFooter stripeBackground='#070808' helpLink="inventory-management/pick-and-verify-orders-with-shopify/" helpDescription="picking and verifying orders" />

      <CorrectScanDialog
        shopify={shopify}
        quantity={dialogQuantity}
        focusScanArea={focusScanArea}
        dialogLineItemId={dialogLineItemId}
        switchUnpickable={switchUnpickable}
      />

      <RepeatScanDialog
        shopify={shopify}
        quantity={dialogQuantity}
        focusScanArea={focusScanArea}
      />

      <IncorrectScanDialog
        shopify={shopify}
        focusScanArea={focusScanArea}
      />
    </Page>
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  pickOrder: state.pickOrder,
  fulfillmentLocations: state.pickOrder.fulfillmentLocations,
  fulfillments: state.pickOrder.fulfillments,
  fulfillmentStatus: state.pickOrder.fulfillmentStatus,
  orderStatuses: state.pickOrder.orderStatuses,
  checkedItems: state.pickOrder.checkedItems,
  incompleteOrders: state.incompleteOrders,
  indexEndCursor: state.incompleteOrders.indexEndCursor,
  indexStartCursor: state.incompleteOrders.indexStartCursor,
  indexHasNextPage: state.incompleteOrders.indexHasNextPage,
  indexHasPreviousPage: state.incompleteOrders.indexHasPreviousPage,
});

const mapDispatchToProps = (dispatch) => ({
  searchOrder: (shopUrl, payload, orderId) => dispatch(readOrder(shopUrl, payload, orderId)),
  submitOrderIndex: (shopUrl, payload, direction, endCursor, startCursor) => dispatch(getIncompleteOrders(shopUrl, payload, direction, endCursor, startCursor)),
  pushCheckedList: (skuList) => dispatch(setCheckedList(skuList)),
  pushUnpickableList: (skuList) => dispatch(setUnpickableList(skuList)),
  resetOrder: () => dispatch(clearOrder()),
  // updateItemQuantity: (shopUrl, payload, orderId, lineItemId, quantity) => dispatch(updateLineItemQuantity(shopUrl, payload, orderId, lineItemId, quantity)),
  pushFulfillment: (shopUrl, payload, fulfillment) => dispatch(createFulfillment(shopUrl, payload, fulfillment))
});

export default connect(mapStateToProps, mapDispatchToProps)(PickOrder);